import { render, staticRenderFns } from "./product.vue?vue&type=template&id=55a7b4b2&scoped=true&%3Ais=view&transition=fade&transition-mode=out-in&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&id=55a7b4b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a7b4b2",
  null
  
)

export default component.exports